import '../../assets/index29.css';var N = Object.defineProperty, S = Object.defineProperties;
var W = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var T = (o, t, e) => t in o ? N(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e, d = (o, t) => {
  for (var e in t || (t = {}))
    v.call(t, e) && T(o, e, t[e]);
  if (i)
    for (var e of i(t))
      w.call(t, e) && T(o, e, t[e]);
  return o;
}, r = (o, t) => S(o, W(t));
var $ = (o, t) => {
  var e = {};
  for (var s in o)
    v.call(o, s) && t.indexOf(s) < 0 && (e[s] = o[s]);
  if (o != null && i)
    for (var s of i(o))
      t.indexOf(s) < 0 && w.call(o, s) && (e[s] = o[s]);
  return e;
};
import { jsx as E } from "react/jsx-runtime";
import { forwardRef as I } from "react";
import { T as M } from "../../Text-B7Ta53Id.js";
const j = "Text-module__root___qmElK", q = "Text-module__prominent___cBfNs", G = "Text-module__detail___g3WvM", J = "Text-module__sm___JZ-O2", K = "Text-module__code___4uIEu", L = "Text-module__md___-u9OG", P = "Text-module__lg___n4BgM", m = {
  root: j,
  prominent: q,
  detail: G,
  sm: J,
  code: K,
  md: L,
  lg: P
}, R = I((Z, C) => {
  var p = Z, {
    "data-plum-id": o,
    className: t,
    component: e,
    children: s,
    prominent: g,
    size: _,
    style: b,
    detail: a,
    code: c,
    truncate: x,
    lineClamp: n,
    gradient: f
  } = p, y = $(p, [
    "data-plum-id",
    "className",
    "component",
    "children",
    "prominent",
    "size",
    "style",
    "detail",
    "code",
    "truncate",
    "lineClamp",
    "gradient"
  ]);
  const O = g ? `${m.root} ${m.prominent}` : m.root, h = a ? m.detail : "", k = c ? m.code : "";
  let u = "", l = d({}, b);
  _ && (_ === "sm" || _ === "md" || _ === "lg" ? u = m[_] : l = r(d({}, l), {
    fontSize: _
  })), x && (l = r(d({}, l), {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  })), n && (l = r(d({}, l), {
    display: "-webkit-box",
    WebkitLineClamp: n,
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  }));
  const B = `${O} ${u} ${h} ${k}`.trim();
  return (
    // @ts-ignore - Ignoring type error with component prop
    /* @__PURE__ */ E(
      M,
      r(d({
        className: t,
        classNames: { root: B },
        component: e,
        style: l,
        variant: f ? "gradient" : void 0,
        gradient: f,
        truncate: x,
        lineClamp: n,
        detail: a,
        code: c,
        ref: C
      }, y), {
        children: s
      })
    )
  );
});
R.displayName = "Text";
export {
  R as Text
};
